import MapContainer from "./MapContainer";

export default MapContainer;
